<template>
  <ad-banner-detail :is-edit='false'>
  </ad-banner-detail>
</template>

<script>
import AdBannerDetail from '../components/AdBannerDetail'
export default {
  name: 'CreateAdBanner',
  components: {
    AdBannerDetail
  }
}
</script>

